import { treaty } from '@elysiajs/eden';
import type { App } from '@infiltre/server/types';

/** Falls back to dev server when `import.meta.env` isn't available (tests/typecheck). */
export const resolveBaseUrl = (): string => {
  const fromEnv = (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_API_URL;
  return fromEnv ?? 'http://localhost:3000';
};

/** Token getter is injected so each platform's identity provider supplies its own bearer source. */
export const createApi = (baseUrl = resolveBaseUrl(), getToken: () => string | null = () => null) =>
  treaty<App>(baseUrl, {
    headers: () => {
      const token = getToken();
      return token ? { authorization: `Bearer ${token}` } : {};
    },
  });

export type Api = ReturnType<typeof createApi>;
